import React, { useEffect, useState } from "react";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import Grid from "@mui/joy/Grid";
import Box from "@mui/joy/Box";
import CardOverflow from "@mui/joy/CardOverflow";
import Divider from "@mui/joy/Divider";
import Avatar from "@mui/joy/Avatar";
import Chip from "@mui/joy/Chip";
import FormControl from "@mui/joy/FormControl";
import Input from "@mui/joy/Input";
import SendIcon from "@mui/icons-material/Send";

export default function MensajeChatCuenta({
  foto_cuenta,
  mensaje_chat_cuenta,
}) {
  let url = process.env.REACT_APP_FRONTEND_URL;
  let linkimagen = process.env.REACT_APP_DOSPACES;

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          gap: "1rem",
          justifyContent: "right",
          marginBottom: "1rem",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#EFE3C2",
            padding: "0.5rem 1rem",
            borderRadius: "8px",
            wordBreak: "break-word",
            overflowWrap: "break-word",
            maxWidth: "15rem",
            fontSize: "0.875rem",
            color: "#333",
            borderTopRightRadius: "0px",
          }}
        >
          {" "}
          <Typography level="body-sm" sx={{ color: "black" }}>
            {mensaje_chat_cuenta ? mensaje_chat_cuenta : null}
          </Typography>
        </Box>
        <Avatar src={`${linkimagen}/uploads/` + foto_cuenta} />
      </Box>
    </div>
  );
}
